/**
 * Єдиний формат deep link (п.23 ТЗ). Компактний рядок, який:
 *  - бот дописує як query-параметр `start` до URL Telegram Mini App у WebApp-кнопці
 *    (простий і надійний спосіб, що працює вже зараз, без реєстрації "короткого імені"
 *    застосунку через @BotFather);
 *  - Mini App при завантаженні перевіряє ОБИДВА можливих джерела — window.location
 *    ("?start=...", коли перехід стався через кнопку бота) і
 *    Telegram.WebApp.initDataUnsafe.start_param (офіційний механізм Telegram для посилань
 *    виду t.me/<bot>/<app>?startapp=..., запрацює одразу, як тільки буде зареєстроване
 *    коротке ім'я застосунку — код для цього вже готовий, міняти нічого не треба).
 *
 * Формат: "<type>:<id1>[:<id2>...]", напр. "car:rav4", "inventory:abc123",
 * "credit:rav4:toyota_legko:36", "proposal:xyz789".
 */

export type DeepLinkTarget =
  | { type: "car"; modelSlug: string }
  | { type: "inventory"; inventoryCarId: string }
  | { type: "used_car"; usedCarId: string }
  | { type: "credit"; modelSlug: string; programCode: string; termMonths: number }
  | { type: "proposal"; proposalId: string };

export function encodeDeepLink(target: DeepLinkTarget): string {
  switch (target.type) {
    case "car":
      return `car:${target.modelSlug}`;
    case "inventory":
      return `inventory:${target.inventoryCarId}`;
    case "used_car":
      return `used_car:${target.usedCarId}`;
    case "credit":
      return `credit:${target.modelSlug}:${target.programCode}:${target.termMonths}`;
    case "proposal":
      return `proposal:${target.proposalId}`;
  }
}

export function decodeDeepLink(raw: string | null | undefined): DeepLinkTarget | null {
  if (!raw) return null;
  const parts = raw.split(":");
  const [type, ...rest] = parts;
  switch (type) {
    case "car":
      return rest[0] ? { type: "car", modelSlug: rest[0] } : null;
    case "inventory":
      return rest[0] ? { type: "inventory", inventoryCarId: rest[0] } : null;
    case "used_car":
      return rest[0] ? { type: "used_car", usedCarId: rest[0] } : null;
    case "credit":
      return rest[0] && rest[1] && rest[2]
        ? { type: "credit", modelSlug: rest[0], programCode: rest[1], termMonths: Number(rest[2]) }
        : null;
    case "proposal":
      return rest[0] ? { type: "proposal", proposalId: rest[0] } : null;
    default:
      return null;
  }
}
